import React from "react";
import { toast } from "react-toastify";
import { format, parse } from "date-fns";
import axios from "axios";
import CryptoJS from 'crypto-js';
import ConsultaContaContabil from "../../lib/json/consultas/ContaContabil.json"
import ConsultaTotvs from "../../backend/ConsultaTotvs";

var matchingItem = null
var indiceFind = ''
var contasProtheus = []

const VariaveisGlobais = (openBar) => {
    const open = openBar;
    return open;
}

const converterObjetoParaArray = (data, prefix = '') => {
    const result = [];
    
    data.forEach(item => {
        result.push({
            indice: item.indice,
            title: item.title,
            to: item.to,
            icon: item.icon,
            actions: item.actions,
            subNav: [],
        });
        
        if (item.subNav && item.subNav.length > 0) {
            const subNavPrefix = `${prefix}${item.indice}.`;
            result.push(...converterObjetoParaArray(item.subNav, subNavPrefix));
        }
    });
    
    return result;
}

const LogoutReset = () => {
    localStorage.removeItem('username');
    localStorage.removeItem('usuarioLogado');
    localStorage.removeItem('empresaFilial');
};

const SucessoMsg = (Mensagem) => toast.success(Mensagem);

const ErroMsg = (Mensagem) => toast.error(Mensagem);

const ErrorMessage = ({ message }) => {
    return <div style={{ color: 'red', marginTop: '10px' }}>{message}</div>;
};

const retornaPerfil = async () => {
    var data = {perfil: []}
    try {
        // Construct the public URL for the JSON file
        const jsonUrl = `/lib/perfilUsuario.json`;
        
        const response = await axios.get(jsonUrl, {
            headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0',
            },
        });
        
        data = await response.data;
    } catch (error) {
        console.error('Error fetching JSON:', error);
    }

    return data
};

const MapeamentoMenu = (array, jsonData) => {
    const result = [];
    const arrayObjeto = converterMenuArray(array);

    arrayObjeto.sort((a, b) => {
        let aIndices = Object.keys(a)[0].split('.').map(Number);
        let bIndices = Object.keys(b)[0].split('.').map(Number);

        for (let i = 0; i < Math.max(aIndices.length, bIndices.length); i++) {
            if (aIndices[i] !== bIndices[i]) {
                return aIndices[i] - bIndices[i];
            }
        }
        
        return 0;
    });

    const ArrayMenu = AjustaArrayMenu(arrayObjeto);
    
    for (let x = 0; x < ArrayMenu.length; x++) {
        const key = ArrayMenu[x]
        const Options = key.split('.')
        const indices = key.split('.').length
        const objectSelect = returnIndexMenu(arrayObjeto,key)
        
        matchingItem = null
        indiceFind = ""
        
        for (let i = 0; i < indices; i++) { 
            indiceFind += ( indiceFind ? '.' : '') + Options[i]
            
            if (matchingItem){
                matchingItem = matchingItem.subNav.find(item => item.indice === indiceFind);
            }else{
                matchingItem = jsonData.find(item => item.indice === indiceFind);
            }
        }
        
        if (matchingItem) {
            const clonedItem = matchingItem ? { ...matchingItem } : null;
            clonedItem.subNav = []

            if (objectSelect.length > 0){
                clonedItem.actions = objectSelect
            }
        
            if (indices > 1){
                matchingItem = null
                indiceFind = ""
                
                for (let i = 0; i < indices -1; i++) { 
                    indiceFind += ( indiceFind ? '.' : '') + Options[i]
                    
                    if (matchingItem){
                        matchingItem = matchingItem.subNav.find(item => item.indice === indiceFind);
                    }else{
                        matchingItem = result.find(item => item.indice === indiceFind);
                    }
                }
                
                matchingItem.subNav.push(clonedItem)
            }else{
                result.push(clonedItem);
            }
        }
    }

    return result;
}

const MapeamentoPermissao = (optionUsuario, centroCustoEmpresa, empresas) =>{
    const uniqueSet = new Set();

    if (empresas){
        const empresasParametros = empresas.map(item => {
            const [code, empresa] = item.split(' - ');
            const mainCode = code.substring(0, 4);
    
            if (!uniqueSet.has(mainCode)) {
                uniqueSet.add(mainCode);
                return mainCode + ' - ' + empresa;
            }
    
            return null;
        }).filter(item => item !== null);
    
        const resultJSON = empresasParametros.map( (empresaNome) => {
            const empresa = empresaNome.split(' - ')[0].trim()
            const centroCustoAux = Object.fromEntries(Object.entries(centroCustoEmpresa.values).filter(([key]) => key.includes(empresa)))
            const centroCusto = centroCustoAux ? centroCustoAux[empresa] : {}
            const aOptionSelect = Object.fromEntries( Object.entries(optionUsuario).filter(([key]) => key.includes(empresa)) );
            const aOptionforJSON = Object.entries(aOptionSelect).filter(([key, value]) => value === true).map(([key]) => key)
            const aOptionJSON = ConvertPermissoes(aOptionforJSON, empresa)
    
            return {
              empresaFilial: empresa,
              centroCusto: centroCusto ? ( centroCusto.map(item => item.value) ) : "",
              centroCustoSelect: centroCusto ? ( centroCusto.map(item => item) ) : "",
              ...aOptionJSON
            };
        })
    
        return resultJSON
    }else{
        return []
    }
   
}

const ConvertPermissoes = (inputArray, cEmpresa) => {
    const resultObject = {
      "incluirSolicitacao": false,
      "visualizarSolicitacao": false,
      "visualizarPedidoCompra": false,
      "avaliarSSMA": false,
    };
  
    inputArray.forEach((key) => {
      const cleanKey = key.replace(cEmpresa, ''); // Remover o prefixo específico
      if (resultObject.hasOwnProperty(cleanKey)) {
        resultObject[cleanKey] = true;
      }
    });
  
    return resultObject;
};

const PermissoesEmpresasJSON = (json) => {
    const resultadoFinal = {};
  
    json.forEach((item) => {
        const { empresaFilial, incluirSolicitacao, visualizarSolicitacao, visualizarPedidoCompra, avaliarSSMA } = item;
    
        // Adicionar propriedades ao objeto final
        resultadoFinal[`${empresaFilial}incluirSolicitacao`] = incluirSolicitacao || false;
        resultadoFinal[`${empresaFilial}visualizarSolicitacao`] = visualizarSolicitacao || false;
        resultadoFinal[`${empresaFilial}visualizarPedidoCompra`] = visualizarPedidoCompra || false;
        resultadoFinal[`${empresaFilial}avaliarSSMA`] = avaliarSSMA || false;
    });
  
    return resultadoFinal;
};

const MenuHabilitadoJSON = (jsonArray) => {
    const resultado = [];
    
    function percorrerArray(array ) {
        array.forEach((item) => {
            const { indice, title, actions } = item;
    
            if (actions){
                actions.map( (acao) => {
                    resultado[`${indice}-${title}-${acao}`] = true;
                })
            }
            
            if (item.subNav && item.subNav.length > 0) {
                percorrerArray(item.subNav, `${indice}`);
            }
        });
    }
    
    percorrerArray(jsonArray);
    
    return resultado;
}

const AjustaArrayMenu = (Objeto) => {
    const keysSet = new Set();

    Objeto.forEach((item) => {
        const [key] = Object.keys(item);
        const parts = key.split('.');

        let currentKey = '';
        parts.forEach((part, index) => {
            currentKey += index === 0 ? part : `.${part}`;
            keysSet.add(currentKey);
        });
    });

    return Array.from(keysSet);
}

const returnIndexMenu = ( objectArray, KeyFind) => {
    const valuesArray = objectArray.filter((item) => KeyFind in item).map((item) => item[KeyFind]);

    return valuesArray.length > 0 ? valuesArray[0] : [];
}

const converterMenuArray = (objeto) => {
    const arrayConvertido = [];

    for (const chave in objeto) {
        if (objeto.hasOwnProperty(chave) && objeto[chave]) {
            const [indice, ,acao] = chave.split('-');
            const encontrado = arrayConvertido.find(item => item[indice]);

            if (encontrado) {
                encontrado[indice].push(acao);
            } else {
                const novoItem = { [indice]: [acao] };
                arrayConvertido.push(novoItem);
            }
        }
    }

    return arrayConvertido;
}

const RetornaUsuarioLogado = (filtraFilial = false, empresaFilial = '') => {
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    usuarioLogado.parametrosEmpresas = JSON.parse(usuarioLogado.parametrosEmpresas)
    usuarioLogado.usuarioProtheus = JSON.parse(usuarioLogado.usuarioProtheus)
    usuarioLogado.menu = JSON.parse(usuarioLogado.menu)
    usuarioLogado.empresasUsuario = usuarioLogado.parametrosEmpresas.map( (item) => item.empresaFilial )
    
    if (usuarioLogado.crmFunil)
        usuarioLogado.crmFunil = JSON.parse(usuarioLogado.crmFunil)

			
    usuarioLogado.solicitacaoPagamento = ( usuarioLogado?.solicitacaoPagamento ?? true )

    if (usuarioLogado.crmAcesso)
        usuarioLogado.crmAcesso = JSON.parse(usuarioLogado.crmAcesso)

    const parametroEmpresaCentroCusto = usuarioLogado.parametrosEmpresas.reduce((acumulador, item) => {
        let centroCusto = [];
    
        if (Array.isArray(item.centroCusto)) {
            centroCusto = item.centroCusto;
        } else if (typeof item.centroCusto === 'string' && item.centroCusto.trim() === '') {
            centroCusto = [];
        }
    
        if (filtraFilial && item.empresaFilial.substr(0,4) === empresaFilial.substr(0,4)) {
            const validos = centroCusto.filter(c => c && c.trim() !== '');
            acumulador.centroCusto.push(...validos);
        } else if (!filtraFilial) {
            const validos = centroCusto.filter(c => c && c.trim() !== '');
            acumulador.centroCusto.push(...validos);
        }
    
        return acumulador;
    }, { centroCusto: [] });

    usuarioLogado.filtraParametroEmpresasCentroCusto = parametroEmpresaCentroCusto

    if (filtraFilial){
        const parametroEmpresaLogada = usuarioLogado.parametrosEmpresas.filter( (item) => item.empresaFilial.substr(0,4) === empresaFilial.substr(0,4))
        usuarioLogado.parametroEmpresasFilialLogada = parametroEmpresaLogada
    }else{
        const parametros = usuarioLogado.parametrosEmpresas;

        const avaliarSSMA = parametros.some(p => p.avaliarSSMA === true);
        const incluirSolicitacao = parametros.some(p => p.incluirSolicitacao === true);
        const visualizarPedidoCompra = parametros.some(p => p.visualizarPedidoCompra === true);
        const visualizarSolicitacao = parametros.some(p => p.visualizarSolicitacao === true);
        usuarioLogado.permissao = {avaliarSSMA, incluirSolicitacao, visualizarPedidoCompra, visualizarSolicitacao}
    }

    return usuarioLogado;
}

function convertSpecialCharsToHtml(text) {
    const htmlText = text
      // 1. Quebra de Linha (\n) para <br/>
      .replace(/\n/g, '<br/>')
      // 2. Remover Espaços em Branco Iniciais e Finais
      .trim()
      // 3. Espaços em Branco Duplos ( ) para &nbsp;
      .replace(/  /g, '&nbsp;')
      // 4. Acentos e Caracteres Especiais
      .replace(/á/g, '&aacute;')
      .replace(/é/g, '&eacute;')
      // Adicione mais substituições conforme necessário
      .replace(/í/g, '&iacute;')
      .replace(/ó/g, '&oacute;')
      .replace(/ú/g, '&uacute;')
      .replace(/â/g, '&acirc;')
      .replace(/ê/g, '&ecirc;')
      .replace(/î/g, '&icirc;')
      .replace(/ô/g, '&ocirc;')
      .replace(/û/g, '&ucirc;')
      .replace(/ä/g, '&auml;')
      .replace(/ë/g, '&euml;')
      .replace(/ï/g, '&iuml;')
      .replace(/ö/g, '&ouml;')
      .replace(/ü/g, '&uuml;')
      .replace(/ß/g, '&szlig;')
      // 5. Citações Simples e Duplas
      .replace(/'/g, '&apos;')
      .replace(/"/g, '&quot;')
      // 6. Símbolos Matemáticos
      .replace(/≠/g, '&ne;')
      .replace(/≈/g, '&asymp;')
      .replace(/≤/g, '&le;')
      .replace(/≥/g, '&ge;')
      // Adicione mais substituições conforme necessário
      ;
  
    return htmlText;
}

function cleanJsonString(jsonString) {
    // Remove tabs, newlines, carriage returns, and multiple whitespaces
    // const cleanedString = jsonString.replace(/[\t\n\r]+/g, ' ').replace(/\s{2,}/g, ' ');
    const cleanedString = jsonString.replace(/[\n\r]+/g, '\\n').replace(/[\t]+/g, " ").replace(/\s{2,}/g, ' ');
  
    // Remove control characters
    const sanitizedString = cleanedString.replace(/[\x00-\x1F\x7F-\x9F]/g, '');
  
    return sanitizedString;
}

function MemoShow(str, lines){
    const numLines = lines || str.split('\n').length;

    return <textarea
        value={str} // Define o valor do TextArea como o HTML formatado
        readOnly // Torna o TextArea somente leitura
        style={{ width: '100%', border: 'none', outline: 'none' }} // Define a largura como 100% e remove a borda e a aparência do foco        
        rows={numLines}
    />
};

function formatarData(valor) {
    try{
        const parsedDataColumn = parse(valor.replaceAll('-','').substring(0,8), 'yyyyMMdd', new Date()) //Tratativa, para ao converter não perder 1 Dia
        return format(parsedDataColumn, "dd/MM/yyyy")
    }catch{
        return valor
    }
}

function parseLocaleNumber(stringNumber) {
  const locale = 'pt-BR';
  const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
  const group = parts.find(p => p.type === 'group').value;
  const decimal = parts.find(p => p.type === 'decimal').value;

  const normalized = stringNumber.replace(new RegExp('\\' + group, 'g'), '')
                                 .replace(new RegExp('\\' + decimal), '.');

  return parseFloat(normalized);
}

function formatarMoeda2(num, decimal){
    // Arredonda para 2 casas decimais
    let valorArredondado = num;

    if (typeof num === 'string'){
        valorArredondado = parseFloat(num.replaceAll('.','').replace(',','.')).toFixed(decimal);
    }

    // Formata como moeda
    const valorFormatado = parseFloat(valorArredondado).toLocaleString('pt-BR', {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  
    return valorFormatado;
}

function formatarMoeda(num, decimal){
    let valorMoeda = num
    if (typeof num !== 'string'){
        valorMoeda = String(num)
    }
    // Remove qualquer caractere que não seja número ou ponto
    const cleanValue = valorMoeda.replace(/[^\d.]/g, '');

    // Se o valor for vazio ou apenas ".", reinicia como 0.00
    if (cleanValue === '' || cleanValue === '.') {
        return '0.'.repeat(decimal);;
    }

    // Divide a parte inteira e a parte decimal com base no ponto
    const parts = cleanValue.split('.');
    let formattedNumber = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ''); // Formata a parte inteira
    
    // Se houver parte decimal, adiciona o ponto e limita a 2 casas decimais
    if (parts[1]) {
        let formattedDecimal = parts[1].slice(0, decimal); // Limita o número de decimais

        // Preenche com zeros se o número de decimais for menor que o definido
        formattedDecimal = formattedDecimal.padEnd(decimal, '0');

        formattedNumber += '.' + formattedDecimal;
    } else {
        // Se não houver decimal, garante que haja casas decimais
        formattedNumber += '.' + '0'.repeat(decimal);
    }

    return formattedNumber;
}

function formatarComoDecimal(valor, nDecimais = 2) {
    // Arredonda para 2 casas decimais
    const valorArredondado = parseFloat(valor).toFixed(nDecimais);
  
    // Formata como moeda
    const valorFormatado = parseFloat(valorArredondado).toLocaleString('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: nDecimais,
      maximumFractionDigits: nDecimais
    });
  
    return valorFormatado;
}

function formatarComoMoeda(valor, nDecimais = 2) {
    // Arredonda para 2 casas decimais
    const valorArredondado = parseFloat(valor).toFixed(nDecimais);
  
    // Formata como moeda
    const valorFormatado = parseFloat(valorArredondado).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: nDecimais,
      maximumFractionDigits: nDecimais
    });
  
    return valorFormatado;
}

function formatDateColumn(item){
    const isMobile = localStorage.getItem('IsMobile')

    if (eval(isMobile)){
        return formatDateColumnCard(item, item.accessor, item.Header) 
    }

    try{
        const parsedDataColumn = parse(item.value.replaceAll('-','').substring(0,8), 'yyyyMMdd', new Date()) //Tratativa, para ao converter não perder 1 Dia
        return format(parsedDataColumn, "dd/MM/yyyy")
    }catch{
        return item.value
    }
}

function formatDateColumnCard(item, acessor, header){
    try{
        const parsedDataColumn = parse(item[acessor].replaceAll('-','').substring(0,8), 'yyyyMMdd', new Date()) //Tratativa, para ao converter não perder 1 Dia
        const valueFormated = format(parsedDataColumn, "dd/MM/yyyy")
        return (<><strong>{header}: </strong> {valueFormated}</>)
    }catch{
        return (<><strong>{header}: </strong>{item[acessor]}</>)
    }
}

function formatValorColumnCard(item, acessor, header){
    return (<p><strong>{header}: </strong>{formatarComoMoeda(item[acessor])}</p>)
}

function formatDateComponent(value){
    try{
        const parsedDataColumn = parse(value, 'dd/MM/yyyy', new Date()) //Tratativa, para ao converter não perder 1 Dia
        return format(parsedDataColumn, "yyyy-MM-dd")
    }catch{
        return value
    }
}

function calcularDiferencaEmDias(dataInicial, dataFinal) {
    const newDataInicial = parse(dataInicial, 'yyyy-MM-dd', new Date());
    const newDataFinal = parse(dataFinal, 'yyyy-MM-dd', new Date());

    const umDiaEmMilissegundos = 1000 * 60 * 60 * 24; // Um dia em milissegundos
  
    // Converte as datas para milissegundos
    const diferencaEmMilissegundos = newDataFinal.getTime() - newDataInicial.getTime();
  
    // Converte a diferença de milissegundos para dias
    const diferencaEmDias = Math.floor(diferencaEmMilissegundos / umDiaEmMilissegundos);
  
    return diferencaEmDias;
}

const optionsStatusSC = [
    {
        value: '99',
        text: "Todos",
        filtroSQL: "( 1 = 1 )"
    },
    {
        value: '0',
        text: "Disponível para Uso",
        filtroSQL: "( ( ( IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) = 0 AND IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' )  OR ( IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) > 0 ) OR ( IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) > 0 AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT AND IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' ) ) AND IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) = 'L' AND IIF(PS1_STATUS = '012', 'S', C1_RESIDUO ) = '' AND NOT( C1_FLAGGCT = 1 AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT ) )"
    },
    {
        value: '1',
        text: "Pendente",
        filtroSQL: "IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) = 0 AND IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' AND IIF(PS1_STATUS = '012', 'S', C1_RESIDUO ) = '' AND IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) = 'L'"
    },
    {
        value: '5',
        text: "Cotação",
        filtroSQL: "IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) != '' AND C1_QUJE < C1_QUANT"
    },
    {
        value: '3',
        text: "Parcialmente",
        filtroSQL: "IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) > 0 AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT AND IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' AND C1_FLAGGCT != 1"
    },
    {
        value: '4',
        text: "Parcialmente em Cotação",
        filtroSQL: "IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) > 0 AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT AND IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) != ''"
    },
    {
        value: '6',
        text: "Eliminado Residuo",
        filtroSQL: "IIF(PS1_STATUS = '012', 'S', C1_RESIDUO ) = 'S' "
    },
    {
        value: '7',
        text: "Em Aprovação",
        filtroSQL: "(IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) = 0 AND (IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' OR IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = 'IMPORT') AND IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) = 'B')"
    },
    {
        value: '8',
        text: "Rejeitada",
        filtroSQL: "(IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) = 0 AND (IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = '' OR IIF(PS1_STATUS IN ('002','009'), 'GOEVO', C1_COTACAO) = 'IMPORT') AND IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) = 'R')"
    },
    {
        value: '9',
        text: "Contrato GCT",
        filtroSQL: "C1_FLAGGCT = 1 AND IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) < C1_QUANT"
    },
    {
        value: '10',
        text: "Devolvida",
        filtroSQL: "IIF(PS1_STATUS IN ('000','007'), 'B', IIF(PS1_STATUS IN ('008','011','013'), 'R', C1_APROV)) IN ('D','0') "
    },
    {
        value: '2',
        text: "Finalizada",
        filtroSQL: "IIF(PS1_STATUS IN ('004','005','006','010','014','015','016','017'), C1_QUANT, C1_QUJE) = C1_QUANT "
    },
]

const optionsPrioridade = [
    {
        value: '1',
        text: "Normal",
    },
    {
        value: '2',
        text: "Regularização",
    },
    {
        value: '3',
        text: "Emergencial",
    },
    {
        value: '5',
        text: "Reposição",
    },
	{
		value: '6',
		text: "Compra Direta",
	}
];

const optionsStatusPC = [
    {
        value: '0',
        text: "Todos",
        filtroSQL: "( 1 = 1 )"
    },
    {
        value: '1',
        text: "Em Aprovação",
        filtroSQL: "( C7_CONAPRO = 'B' AND C7_RESIDUO = '' )"
    },
    {
        value: '2',
        text: "Rejeitado",
        filtroSQL: "( C7_CONAPRO = 'R' AND C7_RESIDUO = '' )"
    },
    {
        value: '3',
        text: "Pendente",
        filtroSQL: "( C7_QUJE + C7_QTDACLA = 0 AND C7_RESIDUO = '' AND C7_CONAPRO = 'L' )"
    },
    {
        value: '4',
        text: "Em Recebimento",
        filtroSQL: "( C7_QTDACLA > 0 AND C7_QUJE + C7_QTDACLA + C7_QUJB <= C7_QUANT AND C7_CONAPRO = 'L' )"
    },
    {
        value: '5',
        text: "Recebido Parcial",
        filtroSQL: "( C7_QUJE > 0 AND C7_QUJE + C7_QUJB < C7_QUANT AND C7_CONAPRO = 'L' )"
    },
    {
        value: '6',
        text: "Recebido",
        filtroSQL: "( C7_QUJE > 0 AND C7_QUJE + C7_QUJB = C7_QUANT AND C7_CONAPRO = 'L' )"
    },
    {
        value: '7',
        text: "Eliminado Residuo",
        filtroSQL: "( C7_QUJB > 0 AND C7_CONAPRO = 'L' )"
    },
]

// Função para criptografar com AES
function encryptAES(text, key) {
  const ciphertext = CryptoJS.AES.encrypt(text, key).toString();
  return ciphertext;
}

// Função para descriptografar com AES
function decryptAES(ciphertext, key) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, key);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
}

function converteDataProtheus(value){
    try{
        let valueFormated = parse(value, 'yyyyMMdd', new Date());
        valueFormated = format(valueFormated, 'yyyy-MM-dd');
    
        return valueFormated
    }catch(e){
        return '';
    }
}

function arredondarParaCima(numero, casasDecimais) {
    const fator = Math.pow(10, casasDecimais);
    return parseFloat(Math.ceil(numero * fator) / fator, casasDecimais);
}

async function retornaDescricaoConta(conta){
    let cDescricao = '';
    if (contasProtheus.length == 0 ){
        const cConsultaDefault = ConsultaContaContabil.consulta + " WHERE D_E_L_E_T_ <> '*' AND CT1_CLASSE = 2 AND CT1_BLOQ = 2 "
        const retConsulta = await ConsultaTotvs(cConsultaDefault, ConsultaContaContabil.tabelas)

        if (retConsulta.data){
            contasProtheus = retConsulta.data
        }
    }

    if (contasProtheus.some(item => item.CT1_CONTA.trim() == conta.trim())){
        cDescricao = contasProtheus.filter(item => item.CT1_CONTA.trim() == conta.trim())[0].CT1_DESC01
    }

    return cDescricao;
}

export { parseLocaleNumber, formatarMoeda, formatarMoeda2, converteDataProtheus, encryptAES, decryptAES, optionsStatusSC, optionsPrioridade, optionsStatusPC, retornaPerfil, converterObjetoParaArray, VariaveisGlobais, LogoutReset, ErrorMessage, SucessoMsg, ErroMsg, MapeamentoMenu, MapeamentoPermissao, PermissoesEmpresasJSON, MenuHabilitadoJSON, RetornaUsuarioLogado, convertSpecialCharsToHtml, cleanJsonString, formatarData,formatarComoMoeda, formatarComoDecimal, formatDateColumn, formatDateColumnCard, formatValorColumnCard, formatDateComponent, MemoShow, calcularDiferencaEmDias, arredondarParaCima, retornaDescricaoConta };